import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "picker-content" }
const _hoisted_2 = {
  key: 0,
  class: "picker-error",
  role: "alert"
}
const _hoisted_3 = {
  class: "preset-list",
  role: "group",
  "aria-label": "预设实体"
}
const _hoisted_4 = ["aria-pressed", "onClick"]
const _hoisted_5 = { class: "preset-info" }
const _hoisted_6 = {
  key: 0,
  class: "selected-mark",
  "aria-label": "当前说话人"
}
const _hoisted_7 = {
  key: 0,
  class: "empty-message"
}

import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from "vue";
import type { EntityPreset } from "../../EntityPresetEditor/entityPresets";
import { studioEditorActiveKey } from "../../studioSessionHistory";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueSpeakerPicker',
  props: {
    presets: {},
    speaker: {},
    error: {}
  },
  emits: ["select", "close", "retry"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const dialog = ref<HTMLDialogElement>();
const editorActive = inject(studioEditorActiveKey, () => true);
const search = ref("");
const namedPresets = computed(() => props.presets.filter(preset => preset.talker.trim()));
const results = computed(() => {
  const query = search.value.trim().toLocaleLowerCase();
  return namedPresets.value.filter(preset => [preset.name, preset.talker].some(value => value.toLocaleLowerCase().includes(query)));
});
onMounted(() => { if (editorActive()) dialog.value?.showModal(); });
watch(editorActive, active => {
  if (!active) { dialog.value?.close(); emit("close"); }
}, { flush: "sync" });
onBeforeUnmount(() => dialog.value?.close());
function select(preset: EntityPreset) {
  emit("select", preset.talker, preset.subtitle);
  dialog.value?.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("dialog", {
      ref_key: "dialog",
      ref: dialog,
      class: "speaker-picker dsfg-typography",
      "aria-labelledby": "speaker-picker-title",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (dialog.value?.close()), ["self"])),
      onPointerdown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
      onKeydown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", null, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { id: "speaker-picker-title" }, "选择说话人", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "close-button",
            "aria-label": "关闭说话人选择",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value?.close()))
          }, "×")
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          class: "search-input",
          type: "search",
          "aria-label": "搜索预设实体",
          placeholder: "搜索实体代号或人名…",
          autofocus: ""
        }, null, 512), [
          [_vModelText, search.value]
        ]),
        (__props.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createTextVNode(_toDisplayString(__props.error) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('retry')))
              }, "重试")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (preset) => {
            return (_openBlock(), _createElementBlock("button", {
              key: preset.id,
              type: "button",
              class: _normalizeClass(["preset-choice", { selected: preset.talker === __props.speaker }]),
              "aria-pressed": preset.talker === __props.speaker,
              onClick: ($event: any) => (select(preset))
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("strong", null, _toDisplayString(preset.name.trim() || preset.talker), 1),
                _createElementVNode("small", null, _toDisplayString(preset.talker), 1)
              ]),
              (preset.talker === __props.speaker)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "✓"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128)),
          (!results.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(namedPresets.value.length ? '没有匹配的实体，试试其他代号或人名。' : '暂无已填写人名的预设实体，可在「预设」中添加。'), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "picker-hint" }, "选择后覆盖说话人和副标题；预设副标题为空时清空原副标题。", -1))
      ])
    ], 544)
  ]))
}
}

})